import { UserTypeEnum } from "./global/enums/UserType.enum";

export class LoginModel {
  userName!: string;
  password!: string;
}

export class User {
  token!: string
  refreshToken!: string
  expiration!: string
  username!: string
  userImage!: string
  displayName: any
  email: any
  groups!: string[]
  UserRoles!: any[]
  showAdminPanel!:boolean
}
